module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu01-fc5f27c82eaad97de5ed11d7805bf7f0.png";